import { ErrorMessage } from "formik";
import React from "react";

export default function EmailInput({ field, form, ...props }) {

    const onChange = event => {
        var val = event.target.value;
        if (val && (val.match(/@/g) || []).length > 1)
            return;
        form.setFieldValue(field.name, val);
    }

    return (
        <div className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}>
            <label className="text-black font-w600">
                {props.label}
                {props.required ? "*" : ""}
            </label>
            <input
                type="email"
                className="form-control"
                placeholder={props.label}
                style={{ height: "calc(1.5em + 1rem + -4px)" }}
                {...field}
                {...props}
                onChange={onChange}
            />
            <ErrorMessage
                name={field.name}
                render={(msg) => (
                    <span className="text-danger">
            <small>*{msg}</small>
          </span>
                )}
            />
        </div>
    );
}
